<template>
    <v-card v-bind="$attrs"  v-if="$listeners.click" :color="color">
         <v-card-text class="text-center" :class="{'pa-1':  dense}" @click="click">
             <v-avatar v-if="avatar">
                 <v-img :src="avatar"></v-img>
             </v-avatar>
             <v-icon v-else-if="icon" :size="size || 78" :color="iconcolor || 'grey'" :class="{'mb-3': !dense, 'mb-1': dense}">{{icon}}</v-icon>
             <h3 class="mb-3" :class="{'grey--text' : !dark, 'primary--text': !dark}" v-if="text">{{text}}</h3>
          <slot name="content">
             <p v-if="description" v-html="description" class="font-weight-light caption" :class="{'ma-0 mb-1': dense, 'grey--text' : !dark, 'primary--text': !dark}"></p>
            </slot>
            
         </v-card-text>
         <v-card-actions v-if="$slots.buttons">
          <slot name="buttons"></slot>
         </v-card-actions>
       </v-card>
       <v-card class="mx-auto text-center" v-bind="$attrs" :class="{'my-2 py-2': !dense, 'transparent' : true}"  flat v-else>
         <v-card-text class="text-center" :class="{'pa-1':  dense}">
             <v-avatar v-if="avatar">
                 <v-img :src="avatar"></v-img>
             </v-avatar>
             <v-icon v-else-if="icon" :size="78" :color="dark ? null : 'primary'" :class="{'mb-3': !dense, 'mb-1': dense}">{{icon}}</v-icon>
             <h3 class="mb-3  text-h4"  :class="{'primary--text': !dark}" v-if="text">{{text}}</h3>
          <slot>
             <p v-if="description" v-html="description" class="font-weight-light" :class="{'ma-0 mb-1': dense, 'primary--text': !dark}"></p>
            </slot>
            <slot name="link"></slot>
         </v-card-text>
         <slot name="content"></slot>
         <slot name="button"></slot>
         <v-card-actions v-if="$slots.buttons">
          <slot name="buttons"></slot>
         </v-card-actions>
       </v-card>
</template>

<script>

export default {
  props: ['icon','color','text', 'description','dense','dark','avatar', 'size','iconcolor'],
   data: () => ({
    
  }),
  computed: {
    
  },
  methods: {
    click(){
        this.$emit('click')
    }
  }
}
</script>